module.exports = __webpack_public_path__ + "static/media/mia-malkova-icon.01ad4902.jpg";